import React from "react";
import { Modal } from "antd";
import { BiDollarCircle } from "react-icons/bi";
import FinancialNotesTab from "./Tabs/FinancialNotesTab";


export default function FinancialReportModal({
  open,
  onClose,
  patientData,
  orderNotes,
  setOrderNotes,
  doctorServices,
  selectedServices,
  setSelectedServices,
  servicesLoading,
  submittingOrder,
  setSubmittingOrder,
  existingOrderReport,
  loadingOrderReport,
  fetchOrderReport,
}) {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={720}
      centered
      title={
        <div className="flex items-center gap-2 text-xl font-bold text-gray-800 pb-2">
          <BiDollarCircle className="text-primary" size={22} />
          Financial Report
        </div>
      }
    >
      <div className="max-h-[75vh] overflow-y-auto pr-1">
        <FinancialNotesTab
          patientData={patientData}
          orderNotes={orderNotes}
          setOrderNotes={setOrderNotes}
          doctorServices={doctorServices}
          selectedServices={selectedServices}
          setSelectedServices={setSelectedServices}
          servicesLoading={servicesLoading}
          submittingOrder={submittingOrder}
          setSubmittingOrder={setSubmittingOrder}
          existingOrderReport={existingOrderReport}
          loadingOrderReport={loadingOrderReport}
          fetchOrderReport={fetchOrderReport}
        />
      </div>
    </Modal>
  );
}